import { render, staticRenderFns } from "./ActiveQueues.vue?vue&type=template&id=14563f30&"
import script from "./ActiveQueues.vue?vue&type=script&lang=ts&"
export * from "./ActiveQueues.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports